/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Wiecej informacji",
  "CookieMessage.old.text":
    "W celu usprawnienia funkcjonowania naszego sklepu internetowego wykorzystujemy pliki cookies. Przeczytaj zasady wykorzystywania plików cookies. ",
  "CookieMessage.link": "Akceptacja Cookies",
  "CookieMessage.more_information":
    "Przeczytaj wiecej na temat plików cookie firmy Kramp",
  "CookieMessage.return": "Wstecz",
  "CookieMessage.intro.body":
    'Pliki cookie zostaly umieszczone przez firme Kramp oraz strony trzecie. Jest oczywiste, ze dbamy o prywatnosc uzytkowników. Klikniecie opcji "Akceptuj pliki cookie" ponizej wyraza zgode uzytkownika na uzycie tych plików cookie. Akceptujac te pliki cookie, zapewniasz prawidlowe funkcjonowanie witryny. Przyklady zastosowania plików cookie:',
  "CookieMessage.intro.list.1": "Automatyczne logowanie na konto uzytkownika",
  "CookieMessage.intro.list.2":
    "Analiza zachowania uzytkownika w celu udoskonalenia witryny",
  "CookieMessage.intro.list.3":
    "Tworzenie profili klientów w celu dostarczania spersonalizowanych ofert i reklam",
  "CookieMessage.intro.extra":
    'Jesli nie chcesz akceptowac wszystkich plików cookie, mozesz zmienic to w <a>ustawieniach</a>. Aby uzyskac wiecej informacji, przeczytaj nasze <a href="{legalLink}">oswiadczenie o ochronie prywatnosci oraz plikach cookie</a>.',
  "CookieMessage.intro.title": "Firma Kramp wykorzystuje pliki cookie",
  "CookieMessage.settings.body":
    'Mozna wybrac pomiedzy trzema ustawieniami plików cookie. Wybranie opcji "standardowe" pozwoli nam zapewnic najlepsze uzytkowanie naszej witryny.',
  "CookieMessage.settings.standard.title": "Standardowe (najpopularniejsze):",
  "CookieMessage.settings.standard.body":
    "pliki cookie wykorzystywane do logowania, zamawiania, analizy, spersonalizowanych ofert, mediów spolecznosciowych i pliki cookie innych stron, zarówno z Europy, jak i spoza niej.",
  "CookieMessage.settings.restricted.title": "Ograniczone:",
  "CookieMessage.settings.restricted.body":
    "pliki cookie wykorzystywane do logowania, zamawiania, analizy i spersonalizowanych ofert.",
  "CookieMessage.settings.highly_restricted.title": "Bardzo ograniczone:",
  "CookieMessage.settings.highly_restricted.body":
    "dopuszczona jest tylko minimalna liczba plików cookie. Sluza one wylacznie do logowania, zamawiania i pozwalaja na dzialanie witrynie w uzasadnionym zakresie.",
  "CookieMessage.settings.options.title":
    "Do czego wykorzystujemy pliki cookie:",
  "CookieMessage.settings.option.1":
    "Uzywamy plików cookie, aby zapewnic prawidlowe dzialanie witryny.",
  "CookieMessage.settings.option.2": "Badamy zachowanie uzytkownika.",
  "CookieMessage.settings.option.3": "Sledzimy statystyki osobiste.",
  "CookieMessage.settings.option.4":
    "Wyswietlamy informacje, które moga byc interesujace.",
  "CookieMessage.settings.option.5": "Uzywamy informacji dla naszych reklam.",
  "CookieMessage.settings.option.6": "Sledzimy anonimowe statystyki.",
  "CookieMessage.settings.option.7": "Udostepniamy Twoje dane osobowe.",
  "CookieMessage.settings.title": "Ustawienia plików cookie",
  "CookiePage.url": "polityka-prywatnosci-cookies",
};
